import { CommApiInstance } from "Utils/CommApiInstance";

const MembNrmlLogoutApi = async () => {
    return await CommApiInstance.post(`athn/logout`,{
        apiBody:{

        },
    })
    .then((Resp) => Resp.data);
}
export default MembNrmlLogoutApi;